<template>
  <div
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    class="modal fade previewer"
    id="markdown_preview"
    role="dialog"
    tabindex="-1"
    data-keyboard="false"
  >
    <div class="modal-dialog" role="document">
      <div class="viewer">
        <div class="viewer-toolbar">
          <div class="dropdown pull-left mobile-menu">
            <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <i class="iconfont icon-list"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li v-if="dialogStatus != 'create' && showDownload">
                <a @click="downloadPreviewData">
                  <i class="ti-download"></i>下载
                </a>
              </li>
              <li v-if="dialogStatus != 'create'">
                <a @click="handlePreviewData('share')" v-show="showShare">
                  <i class="iconfont icon-share"></i>分享
                </a>
              </li>
              <li v-if="dialogStatus != 'create'">
                <a @click="handlePreviewData('move')" v-show="showMoveCopy">
                  <i class="iconfont icon-move"></i>移动
                </a>
              </li>

              <li v-if="dialogStatus != 'create'">
                <a @click="handlePreviewData('copy')" v-show="showMoveCopy">
                  <i class="iconfont icon-copy"></i>复制
                </a>
              </li>
              <li v-if="dialogStatus != 'create'">
                <a @click="deletePreviewData" v-show="showDelete">
                  <i class="iconfont icon-trash"></i>删除
                </a>
              </li>
              <li>
                <a
                  @click="saveFile(false)"
                  v-if="dialogStatus === 'edit' || dialogStatus === 'create'"
                >
                  <i
                    class="fa fa-cloud-upload"
                    :class="[uploading ? 'uploading' : '']"
                  ></i
                  >保存
                </a>
              </li>
            </ul>
          </div>

          <div class="pull-left menu tool">
            <a
              v-show="dialogStatus != 'create' && showDownload"
              @click="downloadPreviewData"
              data-toggle="tooltip"
              data-placement="bottom"
              title="下载"
            >
              <i class="ti-download"></i>
            </a>
            <a
              v-show="dialogStatus != 'create' && showShare"
              @click="handlePreviewData('share')"
              data-toggle="tooltip"
              data-placement="bottom"
              title="分享"
            >
              <i class="iconfont icon-share"></i>
            </a>
            <a
              v-show="dialogStatus != 'create' && showMoveCopy"
              @click="handlePreviewData('move')"
              data-toggle="tooltip"
              data-placement="bottom"
              title="移动"
            >
              <i class="iconfont icon-move"></i>
            </a>
            <a
              v-show="dialogStatus != 'create' && showMoveCopy"
              @click="handlePreviewData('copy')"
              data-toggle="tooltip"
              data-placement="bottom"
              title="复制"
            >
              <i class="iconfont icon-copy"></i>
            </a>
            <a
              v-show="dialogStatus != 'create' && showDelete"
              @click="deletePreviewData"
              data-toggle="tooltip"
              data-placement="bottom"
              title="删除"
            >
              <i class="iconfont icon-trash"></i>
            </a>
            <a
              v-show="dialogStatus === 'edit' || dialogStatus === 'create'"
              @click="saveFile(false)"
              data-toggle="tooltip"
              data-placement="bottom"
              title="保存"
            >
              <i
                class="fa fa-cloud-upload"
                :class="[uploading ? 'uploading' : '']"
              ></i>
            </a>
          </div>

          <div class="pull-right tool">
            <a
              @click="close"
              data-toggle="tooltip"
              data-placement="bottom"
              title="关闭"
            >
              <i class="iconfont icon-close"></i>
            </a>
          </div>

          <div class="cont">
            <div class="name">
              <h4>
                {{ detail.name }}.{{ detail.file_ext }}（{{
                  textMap[dialogStatus]
                }}）
              </h4>
            </div>
          </div>
        </div>
        <div class="viewer-body">
          <div class="loadingbox" v-show="loading">
            <section class="loading Animation1">
              <section class="shape shape-1"></section>
              <section class="shape shape-2"></section>
              <section class="shape shape-3"></section>
              <section class="shape shape-4"></section>
            </section>
            <h4>正在加载，请稍后……</h4>
          </div>
          <article
            :class="[
              column === 'left' ? 'out-of-out' : '',
              column === 'right' ? 'zeroOfhalf' : '',
              column === 'combine' ? 'leftOfhalf' : '',
            ]"
            v-if="
              !loading && (dialogStatus === 'edit' || dialogStatus === 'create')
            "
          >
            <div
              v-if="dialogStatus === 'edit' || dialogStatus === 'create'"
              class="btn-toolbar m-b-sm btn-editor"
            >
              <div class="btn-group pull-right">
                <a
                  class="btn btn-default btn-sm dropdown-toggle"
                  data-toggle="dropdown"
                  title="插入图片"
                  ><i class="fa fa-picture-o"></i
                ></a>
                <div class="dropdown-menu">
                  <div class="input-group m-l-xs m-r-xs">
                    <div class="input-group-btn">
                      <input
                        class="form-control input-sm"
                        placeholder="标题"
                        type="text"
                        v-model.trim="image.title"
                      />
                    </div>
                    <div class="input-group-btn">
                      <input
                        class="form-control input-sm"
                        placeholder="链接"
                        type="text"
                        v-model="image.url"
                      />
                    </div>
                    <div class="input-group-btn">
                      <button
                        class="btn btn-default btn-sm"
                        type="button"
                        @click="addImageContent"
                      >
                        添加
                      </button>
                    </div>
                  </div>
                </div>
                <a
                  v-show="column === 'left'"
                  class="btn btn-default btn-sm"
                  title="切换视图"
                  @click="toggleColumns"
                  ><i class="fa fa-columns"></i
                ></a>
              </div>
              <div class="btn-group pull-right">
                <a
                  class="btn btn-default btn-sm dropdown-toggle"
                  data-toggle="dropdown"
                  title="插入链接"
                  ><i class="fa fa-link"></i
                ></a>
                <div class="dropdown-menu">
                  <div class="input-group m-l-xs m-r-xs">
                    <div class="input-group-btn">
                      <input
                        class="form-control input-sm"
                        placeholder="标题"
                        type="text"
                        v-model.trim="link.title"
                      />
                    </div>
                    <div class="input-group-btn">
                      <input
                        class="form-control input-sm"
                        placeholder="链接"
                        type="text"
                        v-model="link.url"
                      />
                    </div>
                    <div class="input-group-btn">
                      <button
                        class="btn btn-default btn-sm"
                        type="button"
                        @click="addLinkContent"
                      >
                        添加
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-group pull-right">
                <a
                  class="btn btn-default btn-sm"
                  :title="item.name"
                  v-for="(item, index) in editor"
                  :key="index"
                  @click="addContent(item)"
                  ><i class="fa" :class="item.icon"></i
                ></a>
              </div>
              <div class="btn-group pull-right">
                <a
                  class="btn btn-default btn-sm dropdown-toggle"
                  data-toggle="dropdown"
                  ><i class="fa fa-text-height"></i>&nbsp;<b class="caret"></b
                ></a>
                <ul class="dropdown-menu">
                  <li
                    v-for="(item, i) in titles"
                    :key="i"
                    @click="addContent(item)"
                  >
                    <a :style="{ 'font-size': item.size }">{{ item.name }}</a>
                  </li>
                </ul>
              </div>

              <!-- <div class="btn-group pull-right">
                <a
                  class="btn btn-default btn-sm"
                  data-edit="undo"
                  title="撤销"
                  data-original-title="Undo (Ctrl/Cmd+Z)"
                  ><i class="fa fa-undo"></i
                ></a>
                <a
                  class="btn btn-default btn-sm"
                  data-edit="redo"
                  title="回复"
                  data-original-title="Redo (Ctrl/Cmd+Y)"
                  ><i class="fa fa-repeat"></i
                ></a>
              </div -->
            </div>
            <textarea
              id="textarea"
              ref="textarea"
              cols="30"
              rows="10"
              v-model="content"
            ></textarea>
          </article>
          <div v-show="!loading" :class="rightColumnClass">
            <div
              v-if="dialogStatus === 'edit' || dialogStatus === 'create'"
              class="btn-toolbar m-b-sm btn-editor"
            >
              <div class="btn-group pull-right">
                <a
                  class="btn btn-default btn-sm"
                  title="切换视图"
                  @click="toggleColumns"
                  ><i class="fa fa-columns"></i
                ></a>
                <a
                  class="btn btn-default btn-sm"
                  title="Markdown使用说明"
                  :href="url"
                  target="_blank"
                  ><i class="fa fa-question-circle"></i
                ></a>
              </div>
            </div>
            <div class="markdown-warp">
              <article class="markdown-body">
                <VueShowdown
                  :markdown="content"
                  flavor="github"
                  :options="{
                    emoji: true,
                    prefixHeaderId: 'rec-',
                    parseImgDimensions: true,
                    simplifiedAutoLink: true,
                    excludeTrailingPunctuationFromURLs: true,
                    strikethrough: true,
                    ghMentions: false,
                    smoothLivePreview: true,
                  }"
                  :extensions="[extensions]"
                />
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
    <uploader
      ref="uploader"
      :options="options"
      :autoStart="false"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      ><div></div
    ></uploader>
  </div>
</template>

<script>
import "@/assets/css/github-markdown.css";
import Cookies from "js-cookie";
import xml2js from "xml2js";
import {
  preview,
  getFileContent,
  download,
  fileOrFolderInfo,
  getFileUploadUrl,
  fileEditComplete,
  fileComplete,
} from "@/api/drive/drive";
import { info } from "@/api/common/index";
import { getToken, getStorage } from "@/utils/auth";
import {
  sharePreview,
  shareDownload,
  linkTargetPreview,
  linkTargetDownload,
} from "@/api/share/share";
import { VueShowdown } from "vue-showdown";
import "vue-showdown/dist/vue-showdown.esm.js";
import { config } from "@/config/index";
import { getRolePermissions } from "@/utils/permission";
import debounce from "lodash.debounce";
let uploader2 = null;

export default {
  name: "markdownPreview",
  components: {
    VueShowdown,
  },
  props: {
    dialogStatus: {
      type: String,
      default: "view",
    },
    detail: {
      type: Object,
    },
    linkShareNumber: {
      type: String,
    },
    app_save_folder_number: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      resourceLength: false, // 文字内容字数
      isAutoSave: true, // 是否自动更新状态，是，则在上传后显示上传成功的弹框提示
      url: config.url,
      extensions: [
        {
          type: "output",
          filter: (source) => {
            // console.log(this.resourceLength);
            // 自动保存
            if (this.resourceLength === false) {
              this.resourceLength = true;
            } else if (this.resourceLength === true) {
              this.resourceLength = source.length;
            } else if (this.resourceLength !== source.length) {
              this.resourceLength = source.length;
              // this.debouncedUpdate(); // 暂时关闭自动保存
            }

            const regex =
              /(<h([1-6]).*?id="([^"]*?)".*?>(.+?)<\/h[1-6]>)|(<p>(.*?)\[toc\](.*?)<\/p>)/g;

            // find and collect all headers and [toc] node;
            const collection = [];
            source = source.replace(/\[TOC\]/gi, "[toc]");
            // console.log(source);
            source.replace(regex, (wholeMatch, _, level, anchor, text) => {
              // console.log(wholeMatch, level, anchor, text);
              if (
                wholeMatch === "<p>[toc]</p>" ||
                /<p>(.*?)\[toc\](.*?)<\/p>/.test(wholeMatch)
              ) {
                collection.push({ type: "toc" });
              } else {
                text = text.replace(/<[^>]+>/g, "");
                collection.push({
                  type: "header",
                  anchor: anchor,
                  level: Number(level),
                  text: text,
                });
              }
              return "";
            });
            // console.log(collection);

            // calculate toc info
            const tocCollection = [];
            collection.forEach((item, index) => {
              if (item.type === "toc") {
                if (
                  collection[index + 1] &&
                  collection[index + 1].type === "header"
                ) {
                  const headers = [];
                  const levelToToc = collection[index + 1].level;
                  for (let i = index + 1; i < collection.length; i++) {
                    if (collection[i].type === "toc") {
                      break;
                    }
                    const level = collection[i].level;
                    // 根据不同level判断
                    if (level >= levelToToc) {
                      headers.push(collection[i]);
                    } else {
                      break;
                    }
                  }
                  tocCollection.push(headers);
                } else {
                  tocCollection.push([]);
                }
              }
            });
            // console.log(tocCollection[0], tocCollection[1]);

            // replace [toc] node in source
            source = source.replace(/<p>(.*?)\[toc\](.*?)<\/p>/g, () => {
              let headers = tocCollection.shift();

              headers.reverse();

              // console.log(headers);
              if (headers && headers.length) {
                let tagObj = {};
                let prevLevel = null;
                headers.map((item) => {
                  let before = "",
                    after = "";
                  if (!prevLevel || item.level == prevLevel) {
                    before = `<li><a href="#${item.anchor}">${item.text}</a>`;
                    after = "</li>";
                    if (tagObj[item.level]) {
                      tagObj[item.level].unshift(before + after);
                    } else {
                      tagObj[item.level] = [before + after];
                    }
                  } else if (item.level < prevLevel) {
                    before = `<li><a href="#${item.anchor}">${item.text}</a><ol>`;
                    after = "</ol></li>";
                    if (!tagObj[item.level]) {
                      tagObj[item.level] = [];
                    }
                    tagObj[item.level].unshift(
                      before + tagObj[prevLevel].join("") + after
                    );
                    tagObj[prevLevel] = [];
                  } else if (item.level > prevLevel) {
                    before = `<li><a href="#${item.anchor}">${item.text}</a>`;
                    after = "</li>";
                    tagObj[item.level] = [before + after];
                  }
                  // console.log(item.level, tagObj[item.level]);
                  prevLevel = item.level;
                });
                // console.log(tagObj, tagObj[prevLevel].join(""));
                const str = `<ul class="showdown-toc">${tagObj[prevLevel].join(
                  ""
                )}</ul>\n`;
                return str;
              }
              return "";
            });
            return source;
          },
        },
      ],
      image: {
        title: "",
        url: "",
      },
      link: {
        title: "",
        url: "",
      },
      column: "combine", // left-编辑right-显示combine-编辑+显示
      uploading: false,
      loading: true,
      content: "",
      textMap: {
        view: "预览",
        edit: "编辑",
        create: "创建",
      },
      preview_path: "",
      category: "",
      is_preview: "",

      force_cover: 0, // 编辑文件是否强制覆盖：0否1是
      options: {
        allowDuplicateUploads: true, // 允许再次上传
        removeChunkLink: config.api + "/file/swift/batch/delete",
        // target: "//localhost:3000/upload", // 目标上传 URL
        target: [], // 目标上传 URL
        uploadMethod: "post", //默认为post，根据返回参数修改
        chunkSize: 10485760, //分块大小
        fileParameterName: "file0", //上传文件时文件的参数名，默认file
        maxChunkRetries: 10, //最大自动失败重试上传次数
        chunkRetryInterval: 3000, //重试间隔
        testChunks: false, //是否开启服务器分片校验
        simultaneousUploads: 1,
        forceChunkSize: true, //强制所有的块都是小于等于 chunkSize
        permanentErrors: [403],
        parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
          return (
            "剩余" +
            parsedTimeRemaining
              .replace(/\syears?/, "年")
              .replace(/\days?/, "天")
              .replace(/\shours?/, "小时")
              .replace(/\sminutes?/, "分钟")
              .replace(/\sseconds?/, "秒")
          );
        },
        headers: {
          // 在header中添加的验证，请根据实际业务来
          "X-auth-token": getToken(),
        },
      },
      titles: [
        {
          name: "一级标题",
          size: "24px",
          prefix: "\n# ",
          subfix: "",
        },
        {
          name: "二级标题",
          size: "22px",
          prefix: "\n## ",
          subfix: "",
        },
        {
          name: "三级标题",
          size: "20px",
          prefix: "\n### ",
          subfix: "",
        },
        {
          name: "四级标题",
          size: "18px",
          prefix: "\n#### ",
          subfix: "",
        },
        {
          name: "五级标题",
          size: "16px",
          prefix: "\n##### ",
          subfix: "",
        },
        {
          name: "六级标题",
          size: "14px",
          prefix: "\n###### ",
          subfix: "",
        },
      ],
      editor: [
        {
          icon: "fa-bold",
          name: "粗体",
          prefix: "**",
          subfix: "**",
        },
        {
          icon: "fa-italic",
          name: "斜体",
          prefix: "*",
          subfix: "*",
        },
        {
          icon: "fa-underline",
          name: "下划线",
          prefix: "<u>",
          subfix: "</u>",
        },
        {
          icon: "fa-minus",
          name: "分割线",
          prefix: "---",
          subfix: "",
        },
        {
          icon: "fa-strikethrough",
          name: "中划线",
          prefix: "~~",
          subfix: "~~",
        },
        // {
        //   icon: "fa-bookmark",
        //   name: "标记",
        //   prefix: "==",
        //   subfix: "==",
        // },
        {
          icon: "fa-superscript",
          name: "上角标",
          prefix: "<sup>",
          subfix: "</sup>",
        },
        {
          icon: "fa-subscript",
          name: "下角标",
          prefix: "<sub>",
          subfix: "</sub>",
        },
        // {
        //   icon: "fa-align-left",
        //   name: "居左",
        //   prefix: "::: hljs-left",
        //   subfix: ":::",
        // },
        // {
        //   icon: "fa-align-center",
        //   name: "居中",
        //   prefix: "::: hljs-center",
        //   subfix: ":::",
        // },
        // {
        //   icon: "fa-align-right",
        //   name: "居右",
        //   prefix: "\n::: hljs-right\n",
        //   subfix: "\n:::\n",
        // },
        {
          icon: "fa-quote-left",
          name: "段落引用",
          prefix: "\n>",
          subfix: "",
        },
        {
          icon: "fa-code",
          name: "插入代码块",
          prefix: "\n```language\n",
          subfix: "\n```\n",
        },
        // {
        //   icon: "fa-code",
        //   name: "插入代码",
        //   prefix: "`",
        //   subfix: "`",
        // },
        // {
        //   icon: "fa-picture-o",
        //   name: "图片",
        //   prefix: '![图片alt](图片地址 "图片title")',
        //   subfix: "",
        // },
        {
          icon: "fa-link",
          name: "链接",
          prefix: '[超链接名](超链接地址 "超链接title")',
          subfix: "",
        },
        {
          icon: "fa-list-ol",
          name: "有序列表",
          prefix: "1. ",
          subfix: "",
        },
        {
          icon: "fa-list-ul",
          name: "无序列表",
          prefix: "- ",
          subfix: "",
        },
        {
          icon: "fa-tasks",
          name: "任务列表",
          prefix: "* [ ]  ",
          subfix: "",
        },
        {
          icon: "fa-table",
          name: "表格",
          prefix:
            "\n|column1|column2|column3|\n|:--|:--:|--:|\n|content1|content2|content3|\n",
          subfix: "",
        },
      ],
    };
  },
  created() {
    this.debouncedUpdate = debounce(this.updated, 10000, {
      leading: false,
      trailing: true,
    });
  },
  computed: {
    rightColumnClass() {
      if (this.dialogStatus === "preview") {
        return {
          "out-of-out": true,
        };
      }
      let cls = {};
      switch (this.column) {
        case "left":
          cls = {
            zeroOfhalf: true,
          };
          break;
        case "right":
          cls = {
            "out-of-out": true,
          };
          break;
        case "combine":
          cls = {
            rightOfhalf: true,
          };
          break;
        default:
          break;
      }
      return cls;
    },
    showShare() {
      return (
        (["file", "star"].indexOf(this.$store.state.drive.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink" &&
          this.dialogStatus != "create") ||
        (this.$route.name === "markdown" && this.dialogStatus != "create")
      );
    },
    showMoveCopy() {
      return (
        (["file", "star"].indexOf(this.$store.state.drive.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink" &&
          this.dialogStatus != "create") ||
        (this.$route.name === "markdown" && this.dialogStatus != "create")
      );
    },
    showDownload() {
      if (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "markdown"
      ) {
        return true;
      } else if (this.showOnGroupFile) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (this.detail.number && this.detail.parent_number) {
          let number = this.detail.number;
          if (this.detail.parent_number != "0") {
            if (this.detail.parent_path_number) {
              number = this.detail.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf("downloadResource") > -1;
          }
          return false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showDelete() {
      if (
        (["file", "star"].indexOf(this.tab) > -1 &&
          this.$route.name !== "sharelink" &&
          this.$route.name !== "sendlink") ||
        this.$route.name === "markdown"
      ) {
        return true;
      } else if (this.showOnGroupFile) {
        if (this.permissions.resource_operations === "ALL") {
          return true;
        }
        if (this.detail.number && this.detail.parent_number) {
          let number = this.detail.number;
          if (this.detail.parent_number != "0") {
            if (this.detail.parent_path_number) {
              number = this.detail.parent_path_number.slice(1, 37);
            } else {
              // 创建文件夹时，直接给权限
              return true;
            }
          }
          let resource = this.permissions.resource_operations.find((item) => {
            return item.folder_id === number;
          });
          if (resource) {
            let permissions = getRolePermissions(resource.role_type);
            return permissions.indexOf("deleteResource") > -1;
          }
          return false;
        } else {
          return false;
        }
      }
      return false;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    shareNumber() {
      return this.$store.state.drive.share.share_number;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    showOnGroupFile: function () {
      return this.tab === "group-file" || this.tab === "groupdisk-file";
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
  },
  methods: {
    updated() {
      if (this.dialogStatus === "edit") {
        this.saveFile(true);
      }
    },
    // 浏览器关闭时进行用户提示
    beforeunloadHandler(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "您是否确认离开此页面-该页面数据可能不会被保存";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "您是否确认离开此页面-该页面数据可能不会被保存";
    },
    toggleColumns() {
      switch (this.column) {
        case "combine":
          this.column = "left";
          break;
        case "left":
          this.column = "right";
          break;
        default:
          this.column = "combine";
          break;
      }
    },
    getSelectedHtml() {
      let selectedHtml = "";
      const dom = this.$refs.textarea;
      if (
        typeof dom.selectionStart === "number" &&
        typeof dom.selectionEnd === "number"
      ) {
        // console.log(dom.selectionStart, "--", dom.selectionEnd);
        if (dom.selectionStart < dom.selectionEnd) {
          selectedHtml = this.content.substring(
            dom.selectionStart,
            dom.selectionEnd
          );
          // 调试代码
          // dom.focus();
          // dom.setSelectionRange(dom.selectionStart, dom.selectionEnd + 1);
        }
      }
      // console.log(selectedHtml);
      return selectedHtml;
    },
    addImageContent() {
      const edit = {
        prefix: `![${this.image.title}](${this.image.url} "${this.image.title}")`,
        subfix: "",
      };
      this.addContent(edit);
    },
    addLinkContent() {
      const edit = {
        prefix: `[${this.link.title}](${this.link.url} "${this.link.title}")`,
        subfix: "",
      };
      this.addContent(edit);
    },
    addContent(edit) {
      // console.log(edit);
      // return false;
      const dom = this.$refs.textarea;
      if (edit && dom) {
        // console.log(dom);
        if (dom.selection) {
          // console.log("哎嘿，走到dom.selection");
          // var sel = document.selection.createRange();
          // sel.text = str;
        } else if (
          typeof dom.selectionStart === "number" &&
          typeof dom.selectionEnd === "number"
        ) {
          var startPos = dom.selectionStart;
          var endPos = dom.selectionEnd;
          var cursorPos = startPos;
          var tmpStr = dom.value;
          this.content =
            tmpStr.substring(0, startPos) +
            edit.prefix +
            this.getSelectedHtml() +
            edit.subfix +
            tmpStr.substring(endPos, tmpStr.length);
          cursorPos += edit.prefix.length;
          this.$nextTick(() => {
            dom.selectionStart = dom.selectionEnd = cursorPos;
            dom.focus();
          });
        } else {
          // console.log("哎嘿，走到else啦");
          // dom.value += edit.prefix + edit.subfix;
        }
      }
    },
    saveFile(isAutoSave = true) {
      this.isAutoSave = isAutoSave;
      if (this.uploading) {
        return false;
      }
      this.uploading = true;
      const file = new File(
        [this.content],
        this.detail.name + "." + this.detail.file_ext
      );
      uploader2.addFile(file);
    },
    // 配置系统分片大小
    initOptsChunkSize() {
      info()
        .then((res) => {
          if (res.status_code === 200) {
            uploader2.opts.chunkSize = res.entity.chunk_size;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    onFileError(rootFile, file, message, chunk) {
      const parser = new xml2js.Parser();
      parser.parseString(message, (err, result) => {
        let msg = "";
        if ("AccessDenied" === result.Error.Code[0]) {
          msg = "上传失败，失败原因：" + result.Error.Code[0];
        } else {
          msg = "上传失败，失败原因：" + result.Error.Code[0];
        }
        this.$message({
          type: "success",
          message: msg,
        });
      });
    },
    async onFileAdded(file) {
      // 配置系统分片大小
      await this.initOptsChunkSize();
      // 获取所在文件夹number
      const parent_number = this.detail.number
        ? await fileOrFolderInfo({
            number: this.detail.number,
            type: "file",
            is_path: false,
            group_number: this.groupNumber,
          }).then((res) => {
            if (res.status_code === 200) {
              return res.entity.parent_number;
            }
          })
        : this.app_save_folder_number;

      let storage = getStorage();
      // 申请上传地址
      await getFileUploadUrl({
        storage: storage ? storage : "",
        number: parent_number,
        file_name: file.name,
        byte: file.size,
        disk_type: "cloud",
        group_number: this.groupNumber,
        version: this.detail.version,
        force_cover: this.force_cover,
        file_number: this.dialogStatus === "edit" ? this.detail.number : 0,
      })
        .then((res) => {
          if (res.status_code === 200) {
            file.storage = storage;
            file.target = [];
            file.query = [];
            file.chunkSize = res.entity.upload_chunk_size;
            file.upload_token = res.entity.upload_token;
            let upload_params = res.entity.upload_params;
            if (storage === "moss") {
              upload_params.map(function (param) {
                file.target.push(param[1].value);
                file.query.push({
                  chunkUploadMethod: param[2].value,
                });
              });
            } else {
              upload_params.map(function (param) {
                file.target.push(param[0].value);
                file.query.push({
                  max_file_count: param[1].value,
                  max_file_size: param[2].value,
                  expires: param[3].value,
                  signature: param[4].value,
                  chunkUploadMethod: param[6].value,
                });
              });
            }
            file.resume();
          } else if (res.status_code === 5010) {
            this.uploading = false;
            file.cancel();
            this.$confirm({
              type: "confirm",
              showCancleBtn: false,
              showYesBtn: false,
              content: res.message,
              custom: [
                {
                  action: "add",
                  btnText: "新增",
                },
                {
                  action: "cover",
                  btnText: "覆盖",
                },
              ],
            })
              .then((action) => {
                if (action === "add") {
                  this.$message({
                    type: "success",
                    message: "正在新增上传...",
                  });
                  this.force_cover = 0;
                  this.$emit("updateEditToCreateStatus", "create");
                  this.saveFile(false);
                } else if (action === "cover") {
                  this.$emit("changeVersion", res.entity.version);
                  this.$message({
                    type: "success",
                    message: "正在覆盖上传...",
                  });
                  this.force_cover = 1;
                  this.saveFile(false);
                }
              })
              .catch(() => {});
          } else {
            this.uploading = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.uploading = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    onFileSuccess(rootFile, file, response, chunk) {
      if (this.dialogStatus === "create") {
        this.fileComplete(file);
      } else {
        this.fileEditComplete(file);
      }
    },
    fileEditComplete(file) {
      // console.log(this.detail);
      fileEditComplete({
        file_id: this.detail.number,
        upload_token: file.upload_token,
        group_number: this.groupNumber,
        version: this.detail.version,
        force_cover: this.force_cover,
      })
        .then((res) => {
          this.force_cover = 0;
          this.uploading = false;
          if (res.status_code === 200) {
            this.$emit("changeVersion", res.entity.version);
            // if (!this.isAutoSave) {
            this.$message({
              type: "success",
              message: res.message,
            });
            // }
          } else if (res.status_code === 5010) {
            this.$confirm({
              type: "confirm",
              showCancleBtn: false,
              showYesBtn: false,
              content: res.message,
              custom: [
                {
                  action: "add",
                  btnText: "新增",
                },
                {
                  action: "cover",
                  btnText: "覆盖",
                },
              ],
            })
              .then((action) => {
                if (action === "add") {
                  this.$message({
                    type: "success",
                    message: "正在新增上传...",
                  });
                  this.force_cover = 0;
                  this.$emit("updateEditToCreateStatus", "create");
                  this.saveFile(false);
                } else if (action === "cover") {
                  this.$emit("changeVersion", res.entity.version);
                  this.$message({
                    type: "success",
                    message: "正在覆盖上传...",
                  });
                  this.force_cover = 1;
                  this.saveFile(false);
                }
              })
              .catch(() => {});
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.uploading = false;
          this.$message({
            type: "error",
            message: err,
          });
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    fileComplete(file) {
      fileComplete({
        upload_token: file.upload_token,
      })
        .then((res) => {
          this.uploading = false;
          if (res.status_code === 200) {
            this.$emit("changeVersion", res.entity.version);
            this.$message({
              type: "success",
              message: res.message,
            });
            if (this.dialogStatus === "create") {
              this.$emit("updateCreateToEditStatus", {
                number: res.entity.number,
                name: res.entity.name,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.uploading = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    deletePreviewData() {
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          this.$store.commit("operationFileOrFolderData", {
            group_number: this.groupNumber,
            action: this.showOnGroupFile ? "delete" : "recycle",
            disk_type: "cloud",
            files_list: [
              {
                number: this.detail.number,
                type: this.detail.type,
              },
            ],
          });
          this.$store
            .dispatch("handleFileOrFolder", this.detail)
            .then((res) => {
              if (res.status_code === 200) {
                this.$emit("deletePreviewData", this.detail);
                this.close();
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    handlePreviewData(action) {
      this.close();
      this.$emit("handlePreviewData", {
        type: "markdown",
        action: action,
        data: this.detail,
      });
    },
    close() {
      if (this.dialogStatus === "edit" || this.dialogStatus === "create") {
        this.$confirm({
          type: "confirm",
          content: `当前处于编辑状态，确定关闭吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            $("#markdown_preview").modal("hide");
          })
          .catch(() => {});
      } else {
        $("#markdown_preview").modal("hide");
      }
    },
    getFileContent(url) {
      getFileContent(url)
        .then((res) => {
          this.loading = false;
          this.content = res;
          // var reader = new FileReader();
          // reader.onload = () => {
          //   this.content = reader.result;
          // };
          // reader.readAsText(new Blob([res]), "utf-8");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 发布预览
    sendPreview() {
      linkTargetPreview({
        link_number: this.linkShareNumber,
        link_resource_number: this.detail.number,
        link_constraint: {
          password: Cookies.get(this.linkShareNumber),
        },
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
            this.getFileContent(res.entity.preview_path);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享预览
    sharePreview() {
      let share_constraint, share_number;
      if (this.$route.name === "sharelink") {
        share_number = this.linkShareNumber;
        share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        share_number = this.shareNumber;
        share_constraint = null;
      }
      sharePreview({
        share_number: share_number,
        share_resource_number: this.detail.number,
        share_constraint: share_constraint,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
            this.getFileContent(res.entity.preview_path);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 云盘预览
    preview() {
      if (!this.detail.number) {
        this.column = "combine";
        this.content = "## 请输入内容";
        this.loading = false;
        return false;
      }
      preview({
        number: this.detail.number,
        group_number: this.groupNumber,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.preview_path = res.entity.preview_path;
            this.category = res.entity.category;
            this.is_preview = res.entity.is_preview;
            this.getFileContent(res.entity.preview_path);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    edit() {
      this.preview();
    },
    /**
     * 使用download下载的3个地方
     * 1、云盘: route:recdrive, tab:[file, star, sharefile]
     * 2、群盘: route:group, tab:[groupdisk-file]
     * 3、个人中心: route:persona, tab:[persona-file]
     * 4、应用：route:[ppt, word, excel, images, videos]
     * 5、发布资源： route:group,tab:[groupdisk-send]
     * 使用shareDownload下载的4个地方
     * 1、云盘: route:recdrive, tab:[shareme]
     * 2、群盘: route:group, tab:[groupdisk-share, groupdisk-send]
     * 3、个人中心: route:persona, tab:[persona-sharefile]
     * 4、分享链接: route:sharelink
     */
    downloadPreviewData() {
      switch (this.$route.name) {
        case "recdrive":
          if (
            ["file", "star", "sharefile"].indexOf(this.$store.state.drive.tab) >
            -1
          ) {
            this.download();
          } else if ("shareme" === this.$store.state.drive.tab) {
            this.shareDownload();
          }
          break;
        case "groupdisk":
          if (["groupdisk-file"].indexOf(this.$store.state.drive.tab) > -1) {
            this.download();
          } else if (
            ["groupdisk-share", "groupdisk-send"].indexOf(
              this.$store.state.drive.tab
            ) > -1
          ) {
            this.shareDownload();
          }
          break;
        case "persona":
          if ("persona-file" === this.$store.state.drive.tab) {
            this.download();
          } else if ("persona-sharefile" === this.$store.state.drive.tab) {
            this.shareDownload();
          }
          break;
        case "sharelink":
          this.shareDownload();
          break;
        case "sendlink":
          this.sendDownload();
          break;
        default:
          // route:[ppt, word, excel, images, videos]
          this.download();
          break;
      }
    },
    // 云盘资源下载
    download() {
      let params = {
        files_list: [this.detail.number],
        group_number: this.groupNumber,
      };
      download(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.detail.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 分享资源下载
    shareDownload() {
      let params = {
        share_resources_list: [this.detail.number],
      };
      if (this.$route.name === "sharelink") {
        params.share_number = this.linkShareNumber;
        params.share_constraint = {
          password: Cookies.get(this.linkShareNumber),
        };
      } else {
        params.share_number = this.shareNumber;
      }
      shareDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.detail.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 发布资源下载
    sendDownload() {
      let params = {
        link_number: this.linkShareNumber,
        link_constraint: {
          ip: null,
          host: null,
          password: Cookies.get(this.linkShareNumber),
        },
        link_resources_list: [this.detail.number],
      };
      linkTargetDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[this.detail.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },

  mounted() {
    uploader2 = this.$refs.uploader.uploader;
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    $("#markdown_preview").on("show.bs.modal", () => {
      this.$emit("changePreviewStatus", true);
      this.column =
        this.dialogStatus === "edit" || this.dialogStatus === "create"
          ? "combine"
          : "right";
      if (this.$route.name === "sendlink") {
        this.sendPreview();
      } else if (
        (this.shareNumber && this.tab != "sharefile") ||
        this.$route.name === "sharelink"
      ) {
        this.sharePreview();
      } else {
        if (this.dialogStatus === "edit" || this.dialogStatus === "create") {
          this.resourceLength = false;
          this.edit();
          // 当进入编辑界面时，添加关闭浏览器提示
          window.onbeforeunload = this.beforeunloadHandler;
        } else if (this.dialogStatus === "view") {
          this.preview();
        }
      }
    });

    $("#markdown_preview").on("hidden.bs.modal", () => {
      this.preview_path = null;
      this.$emit("changePreviewStatus", false);
      // this.$emit("getInfo");

      if (this.dialogStatus === "edit" || this.dialogStatus === "create") {
        this.resourceLength = false;
        window.onbeforeunload = null;
      }
    });
  },
  destroyed() {
    $("#markdown_preview").off();
  },
};
</script>

<style scoped>
.pre {
  border: none;
  border-radius: 0;
  background-color: #fff;
  height: 100%;
}
.markdown-warp {
  height: 100%;
  overflow: auto;
}
.markdown-body {
  box-sizing: border-box;
  min-width: 200px;
  max-width: 980px;
  margin: 0 auto;
  padding: 45px;
  overflow: auto;
}
.viewer-body {
  display: flex;
  flex-flow: row;
  padding: 42px 2px 2px 2px;
}
.zeroOfhalf {
  display: none;
}
.leftOfhalf {
  width: 50%;
}
.leftOfhalf textarea {
  border-right: 1px solid #e5e5e5 !important;
}
.leftOfhalf textarea,
.out-of-out textarea {
  width: 100%;
  height: calc(100% - 37px);
  padding: 5px 5px 5px 20px;
  resize: none;
  /* border: 1px solid #eaecef; */
  border: none;
}
.leftOfhalf textarea:focus-visible,
.out-of-out textarea:focus-visible {
  outline: none;
}
.rightOfhalf {
  width: 50%;
  height: calc(100% - 37px);
}
.out-of-out {
  width: 100%;
  min-height: 100%;
  overflow: auto;
}
.md-btn-group {
  height: 30px;
  width: 100%;
  text-align: right;
  border-bottom: 1px solid #eaecef;
}
.md-btn {
  /* margin-right: 2px; */
  height: 30px;
  /* width: 40px; */
  line-height: 30px;
  text-align: center;
  display: inline-block;
  padding: 0 8px;
}
.md-btn:hover {
  cursor: pointer;
  background-color: gray;
  color: #fff;
}
::-webkit-scrollbar-thumb {
  width: 6px;
  background: #b7b7b7;
}
::-webkit-scrollbar-track-piece {
  background-color: #e5e5e5;
}
.fa-cloud-upload {
  color: #777;
  padding-top: 4px;
  font-size: 17px;
}
.btn-toolbar {
  padding: 2px 0 4px 0;
  border-bottom: 1px solid #eaecef;
}
.uploading {
  cursor: unset;
  color: #006adf !important;
  animation-name: beat;
  /*动画名称*/
  animation-duration: 0.5s;
  /*设置秒数*/
  animation-timing-function: linear;
  /*速度曲线*/
  animation-iteration-count: infinite;
  /*播放次数*/
  animation-direction: alternate;
  /*逆向播放*/
  animation-play-state: running;
}
.input-group-btn {
  width: auto;
  border-left: 1px solid #e1e1e1;
}

@keyframes beat {
  0% {
    padding-top: 5px;
  }

  100% {
    padding-top: 3px;
  }
}
@media (max-width: 767px) {
  .markdown-body {
    padding: 15px;
  }
}
</style>